import * as React from 'react';
import { useDispatch } from 'react-redux';

import Doc from '../../shared/components/Doc';
import InfoIcon from '../../shared/components/icons/InfoIcon';
import { Dispatch, Modal as IModal, openModal } from '../state';
import Modal from './Modal';

interface IProps extends React.HTMLProps<Element> {
    modal: IModal;
    component: React.ElementType;
    docPath: string;
    children?: React.ReactNode;
}

function WithDocs({ component, modal, children, docPath, ...props }: IProps): JSX.Element {
    const dispatch = useDispatch<Dispatch>();
    const openInfo = () => {
        dispatch(openModal(modal));
    };
    const childrenArray = React.Children.toArray(children);
    childrenArray.push(<InfoIcon key='info-icon' onClick={openInfo} />);
    childrenArray.push(
        <Modal modal={modal} key='modal'>
            <Doc path={docPath} />
        </Modal>,
    );
    props.className = 'with-docs';
    return React.createElement(component, props, childrenArray);
}

export default WithDocs;
